module.exports = "/static/assets/faef218a10693525eaa087f8c26fe2aa.png";